import React from 'react';
import styles from './TrustSection.module.css';

const TrustSection = () => {
  return (
    <section className={styles.trust}>
      <div className={styles.content}>
        <h2>Tu confianza es nuestra prioridad</h2>
        <p>
          En <strong>Megaloto</strong>, garantizamos la seguridad de tus datos y transacciones utilizando tecnología de última generación. Juega con tranquilidad sabiendo que tu información está protegida.
        </p>
        <div className={styles.certifications}>
          <div className={styles.card}>
            <img src="https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/landings%2Fhttps.jpg?alt=media&token=3d3110a4-0382-4957-a23a-003e9d41ed5f" alt="Certificación de Seguridad" />
            <h3>Certificación de Seguridad</h3>
            <p>Contamos con la certificación de instituciones líderes en ciberseguridad.</p>
          </div>
          <div className={styles.card}>
            <img src="https://media.kingston.com/kingston/hero/ktc-articles-blog-data-security-what-is-encryption-hero-lg.jpg" alt="Encriptación Avanzada" />
            <h3>Encriptación Avanzada</h3>
            <p>Usamos SSL y tecnologías avanzadas para proteger todas las transacciones.</p>
          </div>
          <div className={styles.card}>
            <img src="https://strategamagazine.com/wp-content/uploads/2022/01/ana.jpg" alt="Confianza Global" />
            <h3>Confianza Global</h3>
            <p>Licencias y auditorías que aseguran estándares internacionales.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
